import t from "react";
import a from "classnames";
import s from "./index238.mjs";
const g = ({
  stepsLength: o,
  currentIndex: r
}) => /* @__PURE__ */ t.createElement("div", { "data-testid": "progress-container", className: s.progress }, Array.from({ length: o }, (c, e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    key: e,
    "data-testid": "progress-sector",
    className: a({
      [s.progress_sector]: !0,
      [s.progress_sector_active]: e === r,
      [s.progress_sector_finished]: e < r
    })
  }
)));
export {
  g as Progress
};
